export default { 
    SET_CATEGORIA (state, val) {
        state.categoria = val
    }
}